import { _axios } from "../axios";
import { AxiosResponse } from "axios";
import moment from 'moment';

const resource = '/packing';

export function getPackingLocations() {
    return _axios.get(`${resource}` );
}